
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as how_45it_45worksglj_J1RJFLcjSgAMUBgLXcpvquDwclsGCO9ME4VNFmsMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/how-it-works.vue?macro=true";
import { default as overviewKLQnK3hBrIKc8PB48HqO6_mHNU_QycqzYl12y8qBhe8Meta } from "/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/overview.vue?macro=true";
import { default as indexjXEq0ObUSznGA_zHxb6CPDnMyvP_p_c_jQUWZjt_eRUMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/callback/index.vue?macro=true";
import { default as indexmTzUlweqm1Ji92mV3TzblUWEiJTAYzaikeWqdQ2L9BwMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/finalize/index.vue?macro=true";
import { default as depthQz9Da316dEcSYZM00h5m4ibZ8W7Wd5X87Wsd3SPvQI4Meta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/depth.vue?macro=true";
import { default as indexyPD8K8m2Fdvd4OCh7X5Vl2IpITQODLjKkh7muIUP2qUMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/index.vue?macro=true";
import { default as kpixrmbJ_Sd_qdJUyh9UAq4SRA3xXkBnakbRtAE8xnMjPAMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/kpi.vue?macro=true";
import { default as spreadgNVKKm_y5LTiBh3eqeYRzxOXFIh8ZdtYNo_Gigi6of8Meta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/spread.vue?macro=true";
import { default as volumeJAhfK7HPsGhc6e_Norm3odUprNYnjlKKX1a_JonbWAYMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/volume.vue?macro=true";
import { default as newPHsHz7MfrUlOGFNLLR0es9MZlBSbKxOCCvxjnLWK0_UMeta } from "/app/apps/liquidity.forgd.com/layers/engagements/pages/my-active-engagements/new.vue?macro=true";
import { default as leaderboard_45opt_45insWyh5tzP6WYvywHMClYk6Ke5G0CtiRgMLgFtxR_p61IcMeta } from "/app/apps/liquidity.forgd.com/pages/settings/leaderboard-opt-ins.vue?macro=true";
import { default as notifications81bTdahMvJu_d2T1rAjBdJWByO238Zc8gDVDRp_6FPYMeta } from "/app/apps/liquidity.forgd.com/pages/settings/notifications.vue?macro=true";
import { default as teamHa40ISkzphMGIBOZ2FlKeNxGbqMNS1VMxWtseejWMpoMeta } from "/app/apps/liquidity.forgd.com/pages/settings/team.vue?macro=true";
import { default as authorizationT7rIbVB_dKnOAFfAgBAompuF7lHAbbYxPNNuAWLeoZUMeta } from "/app/apps/liquidity.forgd.com/pages/v2/authorization.vue?macro=true";
import { default as _91engagementId_93_f5vvTv048YXXdIm4vOpU6xxiULJQAEFiNdw8eKHem8Meta } from "/app/apps/liquidity.forgd.com/layers/engagements/pages/my-active-engagements/[engagementId].vue?macro=true";
import { default as _91_46_46_46slug_931usqlJmipvTshZ4bE4XIaW3mfslAMEhfyRNEkfWloEAMeta } from "/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/[...slug].vue?macro=true";
import { default as active_45rfqsE5LV1lX4TpTil2DVLzLd6_q_ALU_Nb49aHp_GsEe2_gMeta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/active-rfqs.vue?macro=true";
import { default as api_45keysXPZvwtsTQ4NTo3LczofKAKAb1TpitD_OOhsnMtM_7qgMeta } from "/app/apps/liquidity.forgd.com/layers/api-keys/pages/api-keys.vue?macro=true";
import { default as closed_45rfqsyswkbF3WVmawP_nNExUfO7E_aCAVsQkSLEF1vrVRgREMeta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/closed-rfqs.vue?macro=true";
import { default as indexMDxrahIngFnARYHOB8lFGnsNxmNeLWBObAykDfccCkcMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/confirm-email/index.vue?macro=true";
import { default as indexI_KVW5OAFV_Ne14orK8EpUPspl8_FRkRELLYI4QCbeAMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/email-redirect/index.vue?macro=true";
import { default as indexA7iNbPQ1E0AOSs5JH6W9sV_USpASVWKFpkClryriMwIMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/forgot-password/index.vue?macro=true";
import { default as indexVk0mjjVJVWnK08xCh_yV4E9xZrBz7UdWjwfQ3Azwfl0Meta } from "/app/apps/liquidity.forgd.com/pages/login/index.vue?macro=true";
import { default as indexrs_Y6RVUaS6Aw4LAXajbMuKwf2_VNbRgybvUPehwvjgMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/magic-link/index.vue?macro=true";
import { default as index4GnxqYuGjJCi5LnjPqpHVTwemY8jXabtLxtRINeKeL4Meta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/index.vue?macro=true";
import { default as monitor_45active_45engagementsU1aiAJb_1tTp4fOpMUj4l29segYtpGjznds4CTN8lhYMeta } from "/app/apps/liquidity.forgd.com/layers/monitor-active-projects/pages/monitor-active-engagements.vue?macro=true";
import { default as indexfcJJLfKlFL565IeWm6x8DPvmR0Vbw9mPEjp097sYE20Meta } from "/app/apps/liquidity.forgd.com/layers/engagements/pages/my-active-engagements/index.vue?macro=true";
import { default as indexW2cfYUBvhIraz8oMlgdumxmIdzq4l3d7_8FGyND_F9IMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/page-not-found/index.vue?macro=true";
import { default as quote_45templatesFTZ2wS4WHyebrDik_UcWYffb8lAp1iyumpexIefVU8MMeta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/quote-templates.vue?macro=true";
import { default as reports_45historyK34qHZY_TV_z0Pb7m_NCktHaRKWCf7ypwXOzFaN3jUIMeta } from "/app/apps/liquidity.forgd.com/layers/reports-history/pages/reports-history.vue?macro=true";
import { default as indextJsmddBhNYttOXoorpQh_44uMI__scwcGmyo2eQWHfMMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/reset-password/index.vue?macro=true";
import { default as index7eqz__AguPlXet0ALpOmz8B6lO2_ZYztXMHE6GzRJ3cMeta } from "/app/apps/liquidity.forgd.com/pages/set-password/index.vue?macro=true";
import { default as indexlceDX33GGg8rY5FJQRXR7NCi2ZMcaVbhGt4jOSs5KpwMeta } from "/app/apps/liquidity.forgd.com/pages/settings/index.vue?macro=true";
import { default as indexQLFtDtOMXqoEcm_xTKGWBrFIne7HlxKFrrxE4bHq8lQMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/token-expired/index.vue?macro=true";
import { default as indexZ_OKy2VewP_zbdzzx_njNwZpPCu0XKTRRUkoQ9TuWiYMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/verify-email/index.vue?macro=true";
import { default as round_451_45my_45quotes_1AwZW1gMxq6NyRJ1VjIXbik5IyG9Kbzr0vCyO5bT4IMeta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-1-my-quotes.vue?macro=true";
import { default as round_451_45outcomepDhjKmRBRMcteNQl8NatLxjQ_KfjCF_FVk0oGoOnbJEMeta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-1-outcome.vue?macro=true";
import { default as round_452_45my_45quotesD9tw80dh7ZZHdeEp9ntINX2nnnOU81VEoW4qwGtnFN0Meta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-2-my-quotes.vue?macro=true";
import { default as round_452_45outcomeVwdHA3keSZNLoHhN_rWsoytJLd7qpTLq80HCKN7QMi8Meta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-2-outcome.vue?macro=true";
import { default as summaryun0Jp0QjySMb6E4YljGCONmKm2LSkS0FJV5bE7aTnqAMeta } from "/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/summary.vue?macro=true";
import { default as component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY } from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta } from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "market-maker-leaderboard-documentation-how-it-works",
    path: "/market-maker-leaderboard/documentation/how-it-works",
    meta: how_45it_45worksglj_J1RJFLcjSgAMUBgLXcpvquDwclsGCO9ME4VNFmsMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/how-it-works.vue")
  },
  {
    name: "academy-overview",
    path: "/academy/overview",
    meta: overviewKLQnK3hBrIKc8PB48HqO6_mHNU_QycqzYl12y8qBhe8Meta || {},
    alias: ["/academy"],
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/overview.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: indexjXEq0ObUSznGA_zHxb6CPDnMyvP_p_c_jQUWZjt_eRUMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/callback/index.vue")
  },
  {
    name: "auth-finalize",
    path: "/auth/finalize",
    meta: indexmTzUlweqm1Ji92mV3TzblUWEiJTAYzaikeWqdQ2L9BwMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/finalize/index.vue")
  },
  {
    name: "market-maker-leaderboard-depth",
    path: "/market-maker-leaderboard/depth",
    meta: depthQz9Da316dEcSYZM00h5m4ibZ8W7Wd5X87Wsd3SPvQI4Meta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/depth.vue")
  },
  {
    name: "market-maker-leaderboard-documentation",
    path: "/market-maker-leaderboard/documentation",
    meta: indexyPD8K8m2Fdvd4OCh7X5Vl2IpITQODLjKkh7muIUP2qUMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/index.vue")
  },
  {
    name: "market-maker-leaderboard-kpi",
    path: "/market-maker-leaderboard/kpi",
    meta: kpixrmbJ_Sd_qdJUyh9UAq4SRA3xXkBnakbRtAE8xnMjPAMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/kpi.vue")
  },
  {
    name: "market-maker-leaderboard-spread",
    path: "/market-maker-leaderboard/spread",
    meta: spreadgNVKKm_y5LTiBh3eqeYRzxOXFIh8ZdtYNo_Gigi6of8Meta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/spread.vue")
  },
  {
    name: "market-maker-leaderboard-volume",
    path: "/market-maker-leaderboard/volume",
    meta: volumeJAhfK7HPsGhc6e_Norm3odUprNYnjlKKX1a_JonbWAYMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/volume.vue")
  },
  {
    name: "my-active-engagements-new",
    path: "/my-active-engagements/new",
    meta: { ...(newPHsHz7MfrUlOGFNLLR0es9MZlBSbKxOCCvxjnLWK0_UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/engagements/pages/my-active-engagements/new.vue")
  },
  {
    name: "settings-leaderboard-opt-ins",
    path: "/settings/leaderboard-opt-ins",
    meta: { ...(leaderboard_45opt_45insWyh5tzP6WYvywHMClYk6Ke5G0CtiRgMLgFtxR_p61IcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/pages/settings/leaderboard-opt-ins.vue")
  },
  {
    name: "settings-notifications",
    path: "/settings/notifications",
    meta: { ...(notifications81bTdahMvJu_d2T1rAjBdJWByO238Zc8gDVDRp_6FPYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/pages/settings/notifications.vue")
  },
  {
    name: "settings-team",
    path: "/settings/team",
    meta: { ...(teamHa40ISkzphMGIBOZ2FlKeNxGbqMNS1VMxWtseejWMpoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/pages/settings/team.vue")
  },
  {
    name: "v2-authorization",
    path: "/v2/authorization",
    meta: authorizationT7rIbVB_dKnOAFfAgBAompuF7lHAbbYxPNNuAWLeoZUMeta || {},
    component: () => import("/app/apps/liquidity.forgd.com/pages/v2/authorization.vue")
  },
  {
    name: "my-active-engagements-engagementId",
    path: "/my-active-engagements/:engagementId()",
    meta: { ...(_91engagementId_93_f5vvTv048YXXdIm4vOpU6xxiULJQAEFiNdw8eKHem8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/engagements/pages/my-active-engagements/[engagementId].vue")
  },
  {
    name: "academy-slug",
    path: "/academy/:slug(.*)*",
    meta: _91_46_46_46slug_931usqlJmipvTshZ4bE4XIaW3mfslAMEhfyRNEkfWloEAMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/[...slug].vue")
  },
  {
    name: "active-rfqs",
    path: "/active-rfqs",
    meta: { ...(active_45rfqsE5LV1lX4TpTil2DVLzLd6_q_ALU_Nb49aHp_GsEe2_gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/active-rfqs.vue")
  },
  {
    name: "api-keys",
    path: "/api-keys",
    meta: { ...(api_45keysXPZvwtsTQ4NTo3LczofKAKAb1TpitD_OOhsnMtM_7qgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/api-keys/pages/api-keys.vue")
  },
  {
    name: "closed-rfqs",
    path: "/closed-rfqs",
    meta: { ...(closed_45rfqsyswkbF3WVmawP_nNExUfO7E_aCAVsQkSLEF1vrVRgREMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/closed-rfqs.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    meta: indexMDxrahIngFnARYHOB8lFGnsNxmNeLWBObAykDfccCkcMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/confirm-email/index.vue")
  },
  {
    name: "email-redirect",
    path: "/email-redirect",
    meta: indexI_KVW5OAFV_Ne14orK8EpUPspl8_FRkRELLYI4QCbeAMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/email-redirect/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: { ...(indexA7iNbPQ1E0AOSs5JH6W9sV_USpASVWKFpkClryriMwIMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/forgot-password/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexVk0mjjVJVWnK08xCh_yV4E9xZrBz7UdWjwfQ3Azwfl0Meta || {},
    component: () => import("/app/apps/liquidity.forgd.com/pages/login/index.vue")
  },
  {
    name: "magic-link",
    path: "/magic-link",
    meta: indexrs_Y6RVUaS6Aw4LAXajbMuKwf2_VNbRgybvUPehwvjgMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/magic-link/index.vue")
  },
  {
    name: "market-maker-leaderboard",
    path: "/market-maker-leaderboard",
    meta: index4GnxqYuGjJCi5LnjPqpHVTwemY8jXabtLxtRINeKeL4Meta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/index.vue")
  },
  {
    name: "monitor-active-engagements",
    path: "/monitor-active-engagements",
    meta: { ...(monitor_45active_45engagementsU1aiAJb_1tTp4fOpMUj4l29segYtpGjznds4CTN8lhYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/monitor-active-projects/pages/monitor-active-engagements.vue")
  },
  {
    name: "my-active-engagements",
    path: "/my-active-engagements",
    meta: { ...(indexfcJJLfKlFL565IeWm6x8DPvmR0Vbw9mPEjp097sYE20Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/engagements/pages/my-active-engagements/index.vue")
  },
  {
    name: "page-not-found",
    path: "/page-not-found",
    meta: indexW2cfYUBvhIraz8oMlgdumxmIdzq4l3d7_8FGyND_F9IMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/page-not-found/index.vue")
  },
  {
    name: "quote-templates",
    path: "/quote-templates",
    meta: { ...(quote_45templatesFTZ2wS4WHyebrDik_UcWYffb8lAp1iyumpexIefVU8MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/quote-templates.vue")
  },
  {
    name: "reports-history",
    path: "/reports-history",
    meta: { ...(reports_45historyK34qHZY_TV_z0Pb7m_NCktHaRKWCf7ypwXOzFaN3jUIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/reports-history/pages/reports-history.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(indextJsmddBhNYttOXoorpQh_44uMI__scwcGmyo2eQWHfMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/reset-password/index.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    meta: index7eqz__AguPlXet0ALpOmz8B6lO2_ZYztXMHE6GzRJ3cMeta || {},
    component: () => import("/app/apps/liquidity.forgd.com/pages/set-password/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: { ...(indexlceDX33GGg8rY5FJQRXR7NCi2ZMcaVbhGt4jOSs5KpwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/liquidity.forgd.com/pages/settings/index.vue")
  },
  {
    name: "token-expired",
    path: "/token-expired",
    meta: indexQLFtDtOMXqoEcm_xTKGWBrFIne7HlxKFrrxE4bHq8lQMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/token-expired/index.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: { ...(indexZ_OKy2VewP_zbdzzx_njNwZpPCu0XKTRRUkoQ9TuWiYMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/verify-email/index.vue")
  },
  {
    name: "rfqId-round-1-my-quotes",
    path: "/:rfqId()/round-1-my-quotes",
    meta: { ...(round_451_45my_45quotes_1AwZW1gMxq6NyRJ1VjIXbik5IyG9Kbzr0vCyO5bT4IMeta || {}), ...{"middleware":["auth","rfq-access","rfq-tab-guard"]} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-1-my-quotes.vue")
  },
  {
    name: "rfqId-round-1-outcome",
    path: "/:rfqId()/round-1-outcome",
    meta: { ...(round_451_45outcomepDhjKmRBRMcteNQl8NatLxjQ_KfjCF_FVk0oGoOnbJEMeta || {}), ...{"middleware":["auth","rfq-access","rfq-tab-guard"]} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-1-outcome.vue")
  },
  {
    name: "rfqId-round-2-my-quotes",
    path: "/:rfqId()/round-2-my-quotes",
    meta: { ...(round_452_45my_45quotesD9tw80dh7ZZHdeEp9ntINX2nnnOU81VEoW4qwGtnFN0Meta || {}), ...{"middleware":["auth","rfq-access","rfq-tab-guard"]} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-2-my-quotes.vue")
  },
  {
    name: "rfqId-round-2-outcome",
    path: "/:rfqId()/round-2-outcome",
    meta: { ...(round_452_45outcomeVwdHA3keSZNLoHhN_rWsoytJLd7qpTLq80HCKN7QMi8Meta || {}), ...{"middleware":["auth","rfq-access","rfq-tab-guard"]} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/round-2-outcome.vue")
  },
  {
    name: "rfqId-summary",
    path: "/:rfqId()/summary",
    meta: { ...(summaryun0Jp0QjySMb6E4YljGCONmKm2LSkS0FJV5bE7aTnqAMeta || {}), ...{"middleware":["auth","rfq-access"]} },
    component: () => import("/app/apps/liquidity.forgd.com/layers/rfq/pages/[rfqId]/summary.vue")
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/playbook",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/dashboard",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/privacy-policy",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/terms-conditions",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/terms-of-use",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  }
]